// @ts-expect-error
import startsWith from 'underscore.string/startsWith';

const DEFAULT_SORT_FIELD = 'name';

type EntityListSort = {
    selected: string;
    field: string;
    direction: 'ascending' | 'descending';
};

/**
 * Generates an object consumable by our EntityList component for displaying
 * and handling column header sort.
 *
 * @param  {string} [fieldName='name']  - Optional field name, will default to 'name'
 *                                        if not provided
 * @return {Object}                     - Object containing all keys that our
 *                                        EntityList component expects
 */
export function getSortObjectForEntityList(fieldName?: string): EntityListSort {
    const sortField = fieldName || DEFAULT_SORT_FIELD;

    return {
        selected: sortField,
        field: sortField.replace('-', ''),
        direction: startsWith(sortField, '-') ? 'descending' : 'ascending',
    };
}
